"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerMessageType = exports.ClientMessageType = void 0;
var ClientMessageType;
(function (ClientMessageType) {
    ClientMessageType[ClientMessageType["SUBSCRIBE"] = 0] = "SUBSCRIBE";
    ClientMessageType[ClientMessageType["OPEN_MODAL"] = 1] = "OPEN_MODAL";
    ClientMessageType[ClientMessageType["CLOSE_MODAL"] = 2] = "CLOSE_MODAL";
    ClientMessageType[ClientMessageType["WHATSAPP_SEND"] = 3] = "WHATSAPP_SEND";
    ClientMessageType[ClientMessageType["ACKNOWLEDGE_PROBLEM"] = 4] = "ACKNOWLEDGE_PROBLEM";
})(ClientMessageType || (exports.ClientMessageType = ClientMessageType = {}));
var ServerMessageType;
(function (ServerMessageType) {
    ServerMessageType[ServerMessageType["PROBLEMS"] = 0] = "PROBLEMS";
    ServerMessageType[ServerMessageType["MODALS"] = 1] = "MODALS";
    ServerMessageType[ServerMessageType["MODAL_OPENED"] = 2] = "MODAL_OPENED";
    ServerMessageType[ServerMessageType["MODAL_CLOSED"] = 3] = "MODAL_CLOSED";
    ServerMessageType[ServerMessageType["WHATSAPP_SENT_PROBLEMS"] = 4] = "WHATSAPP_SENT_PROBLEMS";
    ServerMessageType[ServerMessageType["TICKET_SENT_PROBLEMS"] = 5] = "TICKET_SENT_PROBLEMS";
})(ServerMessageType || (exports.ServerMessageType = ServerMessageType = {}));
